import { SkeletonLoader } from './SkeletonLoader';

export const LogPanelSkeleton = () => (
  <div className="glass-card p-4 md:p-5 flex flex-col">
    <div className="flex items-center gap-2 mb-2">
      <SkeletonLoader className="h-4 w-4 rounded" />
      <SkeletonLoader className="h-4 w-32" />
    </div>
    <div className="flex-grow divide-y divide-glass-200/10">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="py-3 space-y-2">
          <div className="flex justify-between items-center">
            <SkeletonLoader className="h-3 w-24" />
            <SkeletonLoader className="h-4 w-16 rounded-full" />
          </div>
          <div className="flex items-start gap-3">
            <SkeletonLoader className="h-4 w-4 rounded" />
            <SkeletonLoader className="h-4 flex-1" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
